import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M21.5 11.5h-13a.5.5 0 0 0 0 1h13a.5.5 0 0 0 0-1M4 13.75a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5m-.875-1.698.177-.177.448.448.948-.948.177.177-1.125 1.125z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }